<script setup lang="ts">
const props = defineProps<{
  context: {
    value: number | undefined
    node: { input: (n: number | undefined) => unknown }
    placeholder?: string
    isDisabled?: boolean
    hideButton?: boolean
    min?: number
    max?: number
    step?: number
    prefix?: string
  } & Record<string, unknown>
}>()

function handleInput(value: number | null) {
  if (!value) {
    return props.context.node.input(undefined)
  }
  props.context.node.input(value)
}
</script>

<template>
  <n-input-number
    :value="context.value"
    size="large"
    :placeholder="context.placeholder"
    :disabled="context.isDisabled"
    :show-button="!context.hideButton"
    :min="context.min"
    :max="context.max"
    :step="context.step"
    @update:value="e => handleInput(e)"
  >
    <template #prefix>
      {{ context.prefix }}
    </template>
  </n-input-number>
</template>
